import { css } from '@emotion/react'
import { typo, zIndex } from '@mathflat/common/style'

const S = {
  layer: css`
    position: fixed;
    inset: 0;
    z-index: ${zIndex.QrCameraLayer};
    display: flex;
    flex-direction: column;
    background: var(--Colors-Gray-900);
    color: var(--White);
  `,
  video: css`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  `,
  top: css`
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    height: 56px;
    padding: 0 16px;
    ${typo.heading05};
    font-weight: 700;
  `,
  closeButton: css`
    display: inline-flex;
    padding: 0;
    border: 0;
    background: none;
    cursor: pointer;
  `,
  topSpacer: css`
    width: 24px;
  `,
  view: css`
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 24px;
  `,
  guide: css`
    position: relative;
    z-index: 1;
    margin: 0;
    font-size: 18px;
    line-height: 1.5;
    font-weight: 700;
    text-align: center;
  `,
  // 네모 밖을 어둡게 덮어 렌즈처럼 보이게 한다
  frame: css`
    --qr-frame-size: min(260px, 64vw);
    position: relative;
    width: var(--qr-frame-size);
    aspect-ratio: 1;
    border-radius: var(--Radius-400);
    box-shadow: 0 0 0 100vmax rgba(0, 0, 0, 0.6);
  `,
  corner: css`
    position: absolute;
    width: 32px;
    height: 32px;
    border: 0 solid var(--White);
  `,
  cornerTopLeft: css`
    top: -2px;
    left: -2px;
    border-top-width: 4px;
    border-left-width: 4px;
    border-top-left-radius: var(--Radius-400);
  `,
  cornerTopRight: css`
    top: -2px;
    right: -2px;
    border-top-width: 4px;
    border-right-width: 4px;
    border-top-right-radius: var(--Radius-400);
  `,
  cornerBottomLeft: css`
    bottom: -2px;
    left: -2px;
    border-bottom-width: 4px;
    border-left-width: 4px;
    border-bottom-left-radius: var(--Radius-400);
  `,
  cornerBottomRight: css`
    right: -2px;
    bottom: -2px;
    border-right-width: 4px;
    border-bottom-width: 4px;
    border-bottom-right-radius: var(--Radius-400);
  `,
  // emotion keyframes 보간이 이 앱 빌드에서 스타일을 통째로 잃는 경우가 있어 이름 있는 @keyframes 를 직접 둔다
  scanLine: css`
    @keyframes qr-scan-line-move {
      from {
        transform: translateY(0);
      }
      to {
        transform: translateY(calc(var(--qr-frame-size) * 0.78));
      }
    }
    position: absolute;
    top: 10%;
    right: 10%;
    left: 10%;
    height: 2px;
    border-radius: var(--Radius-100);
    background: linear-gradient(90deg, transparent 0%, var(--Colors-Sky-400) 50%, transparent 100%);
    box-shadow: 0 0 12px 2px var(--Colors-Sky-400);
    animation: qr-scan-line-move 1800ms ease-in-out infinite alternate;

    @media (prefers-reduced-motion: reduce) {
      transform: translateY(calc(var(--qr-frame-size) * 0.4));
      animation: none;
    }
  `,
  hint: css`
    position: relative;
    z-index: 1;
    margin: 0;
    text-align: center;
    white-space: pre-line;
    ${typo.heading05};
  `,
  hintSub: css`
    color: var(--Colors-Gray-300);
    ${typo.body02};
  `,
  bottom: css`
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    height: 112px;
    padding: 0 32px;
  `,
  albumButton: css`
    display: inline-flex;
    justify-content: center;
    width: 88px;
    padding: 0;
    border: 0;
    background: none;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
    }
  `,
  // 디자인은 가장 최근 사진 썸네일이지만 웹은 앨범 사진을 미리 읽을 수 없어 같은 자리에 아이콘을 둔다
  albumIcon: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: var(--Radius-200);
    background: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 0 2px var(--White);
  `,
  albumSpacer: css`
    width: 88px;
  `,
  shutter: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 72px;
    height: 72px;
    padding: 0;
    border: 4px solid var(--White);
    border-radius: var(--Radius-Circle);
    background: none;
    cursor: pointer;
  `,
  shutterInner: css`
    width: 56px;
    height: 56px;
    border-radius: var(--Radius-Circle);
    background: var(--White);
  `,
  shutterSpacer: css`
    width: 72px;
  `,
  fileInput: css`
    display: none;
  `,
}

export default S
